export default function menuContainerHeight() {
  var windowHeight = window.innerHeight;
  if (window.innerWidth < 824 && $('.menu-active').length) {
    $('#wrapper').css('height', windowHeight);
    $('body').css('height', windowHeight);
  }
}